import React, { useState, useEffect } from "react";
import { AddressModel } from "../../../_models/data.address.model";
import Text from "../inputs/text";
import Row from "../../../styles/layout/row";
import Col from "../../../styles/layout/col";
import { Note } from "../../../styles/forms/inputs";
import { EventTargetType } from "../../../_types/form";
import SelectInput from "./select";
import { Countries } from "../../../config/formData";

interface Props {
	name: string;
	readonly?: boolean;
	onChange: (e: EventTargetType) => void;
	countryError?: string;
	value: AddressModel;
	singleCol?: boolean;
	canEditReadOnly?: boolean;
	note?: string;
	controlledUpdated?: boolean;
	required?: boolean;
}

const AddressCountryInput: React.FC<Props> = ({ name, readonly = false, onChange, countryError, value, singleCol, canEditReadOnly, note, controlledUpdated = false, required }) => {
	let timer: any = null;

	const [state, setState] = useState(new AddressModel(value));

	useEffect(() => {
		if (controlledUpdated) setState(new AddressModel(value));

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [value]);

	const handleChange = ({ target }) => {
		setState((prevState) => ({
			...prevState,
			[target.name]: target.value,
		}));

		clearTimeout(timer);
		timer = setTimeout(() => {
			onChange({
				target: {
					value: new AddressModel({
						...state,
						...{ [target.name]: target.value },
					}),
					type: "address",
					name: name,
				},
			});
		}, 500);
	};

	useEffect(() => {
		setState((prevState) => ({
			...prevState,
			countryError,
		}));
	}, [countryError]);

	return (
		<>
			{note ? <Note>{note}</Note> : null}
			<Row>
				<Col span={singleCol ? 12 : 4} span1024={6} span768={12}>
					<SelectInput
						label="Country"
						name="country"
						value={state.country}
						onChange={handleChange}
						options={Countries}
						error={state.countryError}
						readonly={readonly ? true : false}
						canEditReadOnly={canEditReadOnly}
						includeSearch={true}
						required={required}
					/>
				</Col>
			</Row>
		</>
	);
};
export default AddressCountryInput;
